import { useNavigate } from 'react-router'
import { usePreserveNuqsParams } from '#app/utils/navigation.ts'
import { useWorkspaceId } from '#app/utils/user.ts'
import { IconSetForm } from './icon-set-form'
import { ModalOverlay, Modal, Dialog } from './modal'

interface EditIconSetModalProps {
	uploadedId: string
	initialName: string
	isOpen: boolean
	onOpenChange: (isOpen: boolean) => void
}

export function EditIconSetModal({
	uploadedId,
	initialName,
	isOpen,
	onOpenChange,
}: EditIconSetModalProps) {
	const navigate = useNavigate()
	const buildUrl = usePreserveNuqsParams()
	const workspaceId = useWorkspaceId()

	return (
		<ModalOverlay isOpen={isOpen} onOpenChange={onOpenChange} isDismissable>
				<Modal className="w-full max-w-3xl">
					<Dialog className="p-0">
						<IconSetForm
							mode="edit"
							uploadedId={uploadedId}
							initialName={initialName}
							onClose={() => onOpenChange(false)}
							onDelete={() => {
								if (workspaceId) {
									void navigate(buildUrl(`/workspace/${workspaceId}/icon-sets`))
								}
							}}
						/>
					</Dialog>
				</Modal>
		</ModalOverlay>
	)
}
